/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-08-13T06:54:39.783Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/complianceValidateUserRequest
export const ComplianceValidateUserRequestZod = z.object({
    universe: z.string(),
    accountId: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    dateOfBirth: z.string(),
    emailAddress: z.string(),
    postcode: z.string(),
    mobile: z.string(),
});
export type ComplianceValidateUserRequestType = z.TypeOf<typeof ComplianceValidateUserRequestZod>;


// #/components/schemas/complianceMarkerType
export const ComplianceMarkerTypeZod = z.literal('B1');
export type ComplianceMarkerTypeType = z.TypeOf<typeof ComplianceMarkerTypeZod>;


// #/components/schemas/complianceValidateUserResponse
export const ComplianceValidateUserResponseZod = z.object({
    gamprotectRestriction: z.boolean(),
    reason: z.string().optional(),
    marker: ComplianceMarkerTypeZod.optional(),
    brand: z.string().optional(),
});
export type ComplianceValidateUserResponseType = z.TypeOf<typeof ComplianceValidateUserResponseZod>;


// #/components/schemas/complianceApiError
export const ComplianceApiErrorZod = z.object({
    code: z.number(),
    message: z.string(),
});
export type ComplianceApiErrorType = z.TypeOf<typeof ComplianceApiErrorZod>;


// #/components/schemas/complianceApiErrorResponse
export const ComplianceApiErrorResponseZod = z.object({
    error: ComplianceApiErrorZod,
});
export type ComplianceApiErrorResponseType = z.TypeOf<typeof ComplianceApiErrorResponseZod>;


// #/components/schemas/complianceRemoveUserRequest
export const ComplianceRemoveUserRequestZod = z.object({
    universe: z.string(),
    accountId: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    dateOfBirth: z.string(),
    emailAddress: z.string(),
    postcode: z.string(),
    mobile: z.string(),
    removeReason: z.string(),
});
export type ComplianceRemoveUserRequestType = z.TypeOf<typeof ComplianceRemoveUserRequestZod>;


// #/components/schemas/complianceEmptyResponse
export const ComplianceEmptyResponseZod = z.unknown();
export type ComplianceEmptyResponseType = z.TypeOf<typeof ComplianceEmptyResponseZod>;


// #/components/schemas/complianceSubmitUserRequest
export const ComplianceSubmitUserRequestZod = z.object({
    universe: z.string(),
    accountId: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    dateOfBirth: z.string(),
    emailAddress: z.string(),
    postcode: z.string(),
    mobile: z.string(),
    entryReason: z.string(),
});
export type ComplianceSubmitUserRequestType = z.TypeOf<typeof ComplianceSubmitUserRequestZod>;


// #/components/schemas/complianceGamstopAccountState
export const ComplianceGamstopAccountStateZod = z.unknown();
export type ComplianceGamstopAccountStateType = z.TypeOf<typeof ComplianceGamstopAccountStateZod>;


// #/components/schemas/complianceDatabaseMarkers
export const ComplianceDatabaseMarkersZod = z.object({
    id: z.number(),
    gamprotectId: z.string(),
    firstSeen: z.string(),
    lastSeen: z.string().optional(),
    entryReason: z.string(),
    deletionReason: z.string().optional(),
    brand: z.string(),
    marker: ComplianceMarkerTypeZod,
    universe: z.string(),
    accountId: z.number(),
});
export type ComplianceDatabaseMarkersType = z.TypeOf<typeof ComplianceDatabaseMarkersZod>;


// #/components/schemas/complianceGamprotectAccountState
export const ComplianceGamprotectAccountStateZod = z.object({
    active: z.boolean(),
    markers: z.array(ComplianceDatabaseMarkersZod),
});
export type ComplianceGamprotectAccountStateType = z.TypeOf<typeof ComplianceGamprotectAccountStateZod>;


// #/components/schemas/complianceGetAccountStateResponse
export const ComplianceGetAccountStateResponseZod = z.object({
    universe: z.string(),
    accountId: z.number(),
    gamstop: ComplianceGamstopAccountStateZod,
    gamprotect: ComplianceGamprotectAccountStateZod,
});
export type ComplianceGetAccountStateResponseType = z.TypeOf<typeof ComplianceGetAccountStateResponseZod>;

